module.exports = $, jQuery;